/* eslint-disable @typescript-eslint/no-unused-vars */
import Button from "@mui/material/Button";
import styled from "styled-components";
import materialUI from "material-UI";
import color from "../../../../constants/color";

export const Container = styled.div`
  width: 100%;
`;

export const BodyTable = styled.div`
  width: 100%;
  margin-top: 1rem;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const HeaderTarefas = styled.div`
  width: 100%;
`;

export const Text = styled.p`
  margin: 0 auto;
  font-family: "Inter";
  font-size: 14px;
  color: ${color.grey9};
`;

export const CardsSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 10vh;
  padding-top: 24px;
`;

export const StandartCard = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 2px 4px 0px #3030301f;
  border-radius: 1rem;
  font-family: "Inter";
  hr {
    width: 100%;
    background-color: #d5d5d5;
    border: 1px;
    height: 1px;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GridContent = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
`;

export const CardContent = styled.div`
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  gap: 8px;
`;

export const CardContentFooter = styled.div`
  display: flex;
  gap: 24px;
`;

export const CardGridIcons = styled.div`
  display: flex;
  gap: 4px;
  letter-spacing: -0.01em;
  text-align: left;
  h3 {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    color: #333333;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: -0.01em;
    color: #000000de;
  }
`;

export const ButtonsGrid = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  justify-content: right;
  align-items: center;
`;

interface ButtonProps {
  isSelected: boolean;
}

export const ButtonTarefas = styled.button<ButtonProps>`
  width: 100px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background-color: ${(props) => (props.isSelected ? "#2D5BFF" : "#EAEFFF")};
  color: ${(props) => (props.isSelected ? "#FFFFFF" : "#2D5BFF")};
  text-align: left;
  cursor: pointer;
`;

export const HeaderTable = styled.div`
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 32px 0;
  align-items: center;
  height: 40px;
  margin-bottom: 25px;

  background-color: rgba(0, 0, 0, 0.04);
  p {
    //styleName: Typography/Body 1;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
    color: #000000de;
  }
  .col-1 {
    margin-left: 24px;
    flex: 4;
    text-align: left;
  }
  .col-2 {
    flex: 2;
    text-align: left;
  }
  .col-3 {
    flex: 1.5;
    text-align: left;
  }
  .col-4 {
    flex: 1.5;
    text-align: left;
  }
  .col-5 {
    flex: 0.5;
  }
`;

export const ItemTable = styled.div`
  border-radius: 3px;
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
`;

export const ItemsList = styled.div`
  min-height: 200px; // or any minimum height you prefer
  max-height: 560px; // optional, remove if you don't want to limit the maximum height
  width: 100%;
  overflow-y: auto; // allows scrolling when content overflows

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #d5d5d5;
  }
`;

export const GradientButton = styled(Button).attrs({
  fullWidth: true,
})`
  background-image: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  color: #ffffff !important;
  height: 40px;
  border-radius: 8px !important;
  font-family: "Inter" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 150% !important;
`;

export const DescriptionContainer = styled.div`
  width: 100%;
  min-height: 50px;
  margin-top: 10px;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #d5d5d51a;
  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: -0.01em;
    text-align: left;
  }
  .title {
    color: #646363;
    margin-bottom: 0.25rem;
  }
  .content {
    color: #303030;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  width: 400px;
  height: 600px;
`;

export const HeaderModal = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderModalTitle = styled.p`
  font-family: Roboto;
  font-weight: 400;
  font-size: 34px;
  line-height: 123.5%;
  letter-spacing: 0.25px;
  color: ${color.fullBlack};
`;

export const ClearBtn = styled.p`
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${color.primary};
  cursor: pointer;
`;

export const FooterModal = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
  padding: 24px;
  border-top: 1px solid ${color.LigthGrey};
  width: 100%;
`;

export const ButtonModal = styled(materialUI.Button)`
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  color: #ffffff !important;
  border-radius: 8px;
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.01em;
  font-family: Inter-Medium;
  color: ${color.White};
  text-transform: capitalize;
  padding: 16px;
`;

export const LocalizationProvider = styled(materialUI.LocalizationProvider)`
  display: flex;
  align-items: center;
`;

export const ContentDate = styled.div`
  width: 50%;

  &:first-of-type {
    margin-right: 8px;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const DesktopDatePicker = styled(materialUI.DesktopDatePicker)`
  .Mui-disabled {
    background-color: rgb(242, 244, 248);
  }
`;

export const LabelText = styled.span`
  display: block;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  width: 100%;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${color.primary} !important;
    }
  }
  .MuiOutlinedInput-input {
    padding-top: 10.5px;
    padding-bottom: 10.5px;
  }
`;

export const LabelModal = styled.p`
  font-family: Inter-Medium;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.01em;
  color: ${color.fullBlack};
  margin-bottom: 11px;
`;
